import spongcakeround from "../images/spongecakeround.jpg";
import strawberryflake from "../images/strawberryflake.jpg";
import fruitsofeden from "../images/fruitsofeden.jpg";
import chocolatesplash from "../images/chocolatesplash.jpg";
import rosiescake from "../images/rosiescake.jpg";
import bowcake from "../images/bowcake.jpg";
import redvelvet from "../images/redvelvet.jpg";
import dripdelux from "../images/dripdelux.jpg";
import bluewavecake from "../images/bluewavecake.jpg";
import theclassicsquare from "../images/theclassicsquare.jpg";
import theflakecake from "../images/flakecake.jpg";
import summerdelight from "../images/summerdelight.jpg";
import chocolatefruitdipip from "../images/chocolatefruitdip.jpg";
import biscoffdrip from "../images/biscoffdrip.jpg";
import chocolatesplashsquare from "../images/chocolatesplashsquare.jpg";
import vintageheartbow from "../images/vintageheartbow.jpg";
import dripheartcake from "../images/dripheartcake.jpg";
import peachheartcake from "../images/peachheartcake.jpg";
import egyptiancottoncake from "../images/egyptiancottoncake.jpg";
import pinkwhiteheart from "../images/pinkwhiteheart.jpg";
import purpleheart from "../images/purpleheart.jpg";
import spidermancake from "../images/spidermancakeround.jpg";
import teamcake from "../images/teamcake.jpg";
import mickeymouse from "../images/mickeymouse.jpg";
import barbiecake from "../images/barbiecake.jpg";
import minniemouse from "../images/minniemouse.jpg";
import peppapigcake from "../images/peppapigcake.jpg";
import babysharkcake from "../images/babyshark.jpg";
import blueycake from "../images/blueycake.jpg";
import numbercake from "../images/numbercake.jpg";
import chocolateandfruitcake from "../images/chocolateandfruits.jpg";
import welcomecake from "../images/welcomecake.jpg";
import vanillagiftbox from "../images/vanillagiftbox.jpeg";
import chocolategiftbox from "../images/chocolategiftbox.jpeg";
import redvelvetgiftbox from "../images/redvelvetgiftbox.jpeg";
import slicesimage from "../images/slices.jpg";

// Helper function: Takes an object of sizes and prices and converts it for the UI
const setSizes = (sizePrices) => {
  return Object.keys(sizePrices).map((size) => ({
    size: size,
    price: sizePrices[size],
  }));
};

export const productsData = [
  // --- Round Cakes ---
  {
    id: 1,
    name: "The Classic Cake (R01)",
    price: "From £16",
    sizes: setSizes({
      "6 Inch": 16,
      "8 Inch": 18,
      "10 Inch": 27,
      "12 Inch": 37,
      "14 Inch": 47,
      "16 Inch": 59,
    }),
    category: "Round",
    desc: "Simple and elegant white vanilla sponge.",
    longDesc:
      "Our signature classic is an exercise in restraint and perfection. Three layers of incredibly moist, egg-free Madagascan vanilla Madeira sponge are gently layered with a whipped white chocolate ganache. Finished with a perfectly smooth buttercream.",
    image: spongcakeround,
  },
  {
    id: 2,
    name: "Fruits of Eden (R02)",
    price: "From £28",
    sizes: setSizes({
      "8 Inch": 28,
      "10 Inch": 38,
      "12 Inch": 48,
      "14 Inch": 58,
      "16 Inch": 73,
    }),
    category: "Round",
    desc: "Fresh seasonal fruits atop a classic cream base.",
    longDesc:
      "An orchard in every bite. This vibrant creation features layers of light, egg-free vanilla Madeira sponge soaked in a subtle citrus syrup, generously filled with a medley of fresh, hand-cut seasonal fruits and Chantilly cream.",
    image: fruitsofeden,
  },
  {
    id: 3,
    name: "Strawberry Flake (R03)",
    price: "From £21",
    sizes: setSizes({
      "8 Inch": 21,
      "10 Inch": 31,
      "12 Inch": 41,
      "14 Inch": 51,
      "16 Inch": 64,
    }),
    category: "Round",
    desc: "A beautiful arrangement of fresh strawberries and chocolate flakes.",
    longDesc:
      "A celebration of summer. We source hand-picked seasonal strawberries and crown them atop a delicate, egg-free elderflower-infused Madeira sponge, accented perfectly with delicate chocolate flakes.",
    image: strawberryflake,
  },
  {
    id: 4,
    name: "Chocolate Splash (R04)",
    price: "From £28",
    sizes: setSizes({
      "8 Inch": 28,
      "10 Inch": 41,
      "12 Inch": 51,
      "14 Inch": 65,
      "16 Inch": 75,
    }),
    category: "Round",
    desc: "Rich chocolate cake with a dramatic dark chocolate splash.",
    longDesc:
      "The ultimate indulgence. Rich, egg-free chocolate sponge layered with Belgian chocolate buttercream, finished with a dramatic dark chocolate splash and crowned with rich cocoa truffles.",
    image: chocolatesplash,
  },
  {
    id: 5,
    name: "Rosie's Cake (R05)",
    price: "From £35",
    sizes: setSizes({
      "8 Inch": 35,
      "10 Inch": 47,
      "12 Inch": 59,
      "14 Inch": 73,
    }),
    category: "Round",
    desc: "Beautiful floral piping with delicate accents.",
    longDesc:
      "A cake fit for royalty. Intricate watercolor buttercream encases a rich, egg-free Madeira sponge, finished with delicate floral accents and bespoke piping that creates a striking visual centerpiece.",
    image: rosiescake,
  },
  {
    id: 6,
    name: "Bow Cake (R06)",
    price: "From £30",
    sizes: setSizes({
      "8 Inch": 30,
      "10 Inch": 41,
      "12 Inch": 55,
    }),
    category: "Round",
    desc: "A flawlessly smooth base adorned with a signature bow.",
    longDesc:
      "Elegance defined. A flawlessly smooth buttercream exterior is adorned with an intricate, hand-crafted sugar bow, concealing a luscious egg-free vanilla Madeira sponge with a raspberry and white chocolate interior.",
    image: bowcake,
  },
  {
    id: 7,
    name: "Red Velvet (R07)",
    price: "From £25",
    sizes: setSizes({
      "6 Inch": 25,
      "8 Inch": 39,
      "10 Inch": 57,
    }),
    category: "Round",
    desc: "Vibrant traditional red velvet with cream cheese frosting.",
    longDesc:
      "A classic done right. Our signature egg-free red velvet sponge is layered with perfectly tangy cream cheese frosting and finished with a smooth, flawless exterior.",
    image: redvelvet,
  },
  {
    id: 8,
    name: "Drip Deluxe (R08)",
    price: "From £34",
    sizes: setSizes({
      "8 Inch": 34,
      "10 Inch": 46,
      "12 Inch": 62,
      "14 Inch": 79,
    }),
    category: "Round",
    desc: "Our premium drip cake loaded with toppings.",
    longDesc:
      "A textural masterpiece. Layers of egg-free chocolate sponge are sandwiched between rich buttercream, topped with a dramatic chocolate drip and an overload of premium confections.",
    image: dripdelux,
  },
  {
    id: 9,
    name: "Blue Wave Cake (R09)",
    price: "From £30",
    sizes: setSizes({
      "8 Inch": 30,
      "10 Inch": 40,
      "12 Inch": 52,
      "14 Inch": 69,
      "16 Inch": 87,
    }),
    category: "Round",
    desc: "Stunning blue textured ocean wave frosting.",
    longDesc:
      "A structural marvel. The exterior features stunning, hand-piped textured buttercream in graduating shades of azure blue, encasing a zesty lemon and blueberry infused egg-free Madeira sponge.",
    image: bluewavecake,
  },

  // --- Square Cakes ---
  {
    id: 10,
    name: "The Classic Square (S01)",
    price: "From £23",
    sizes: setSizes({
      "8 Inch": 23,
      "10 Inch": 36,
      "12 Inch": 47,
      "14 Inch": 61,
      "16 Inch": 69,
      "18 Inch": 88,
      "18 x 30 Inch": 138,
    }),
    category: "Square",
    desc: "A sleek, minimalist square vanilla cake.",
    longDesc:
      "The epitome of modern minimalism. A razor-sharp square architectural build featuring pure white Madagascar vanilla buttercream over layers of delicate, egg-free vanilla Madeira sponge and apricot preserve.",
    image: theclassicsquare,
  },
  {
    id: 11,
    name: "Flake Cake (S02)",
    price: "From £27",
    sizes: setSizes({
      "8 Inch": 27,
      "10 Inch": 40,
      "12 Inch": 56,
      "14 Inch": 68,
      "16 Inch": 81,
      "18 Inch": 105,
      "18 x 30 Inch": 145,
    }),
    category: "Square",
    desc: "A sharp square cake generously covered in chocolate flakes.",
    longDesc:
      "Vintage charm meets modern chocolate execution. This perfect square cake features rich chocolate borders and is generously topped with crumbly, delicate chocolate flakes over a moist, egg-free chocolate sponge.",
    image: theflakecake,
  },
  {
    id: 12,
    name: "Summer Delight (S03)",
    price: "From £28",
    sizes: setSizes({
      "8 Inch": 28,
      "10 Inch": 42,
      "12 Inch": 57,
      "14 Inch": 68,
      "16 Inch": 84,
      "18 Inch": 110,
      "18 x 30 Inch": 165,
    }),
    category: "Square",
    desc: "Decorated with an abundance of summer fruits.",
    longDesc:
      "A geometric delight. Vibrant fresh berries and velvety cream create a striking modern arrangement on top of this sharp-edged, passionfruit-infused egg-free Madeira sponge.",
    image: summerdelight,
  },
  {
    id: 13,
    name: "Biscoff Drip (S04)",
    price: "From £32",
    sizes: setSizes({
      "8 Inch": 32,
      "10 Inch": 45,
      "12 Inch": 63,
      "14 Inch": 76,
    }),
    category: "Square",
    desc: "Square base finished with a rich cookie butter drip.",
    longDesc:
      "Decadence squared. A rich, egg-free brown sugar Madeira sponge layered with Biscoff cookie buttercream, finished with razor-sharp edges and a flawless, dripping crown of melted cookie butter.",
    image: biscoffdrip,
  },
  {
    id: 14,
    name: "Chocolate Fruit Drip (S05)",
    price: "From £32",
    sizes: setSizes({
      "8 Inch": 32,
      "10 Inch": 45,
      "12 Inch": 64,
      "14 Inch": 73,
      "16 Inch": 91,
      "18 Inch": 115,
    }),
    category: "Square",
    desc: "Loaded with an abundance of fruits and chocolate drip.",
    longDesc:
      "For those who want it all. A premium, oversized square canvas topped with an artful abundance of fresh berries and a rich chocolate drip, covering a decadent, egg-free marble Madeira and chocolate sponge.",
    image: chocolatefruitdipip,
  },
  {
    id: 15,
    name: "Chocolate Splash - Square (S06)",
    price: "From £33",
    sizes: setSizes({
      "8 Inch": 33,
      "10 Inch": 46,
      "12 Inch": 62,
      "14 Inch": 75,
    }),
    category: "Square",
    desc: "Decadent chocolate square topped with our signature splash.",
    longDesc:
      "A classic pairing presented in a modern geometry. Dense, egg-free chocolate sponge forms the base, topped with our signature chocolate splash technique and a dusting of premium cocoa.",
    image: chocolatesplashsquare,
  },

  // --- Heart Cakes ---
  {
    id: 16,
    name: "Vintage Heart Bow (H01)",
    price: "From £34",
    sizes: setSizes({
      "8 Inch": 34,
      "10 Inch": 45,
      "12 Inch": 59,
      "14 Inch": 75,
    }),
    category: "Heart",
    desc: "Vintage piped heart cake with delicate bows.",
    longDesc:
      "The ultimate gesture of affection. A perfectly sculpted heart-shaped, egg-free Madeira sponge, finished in pristine buttercream and framed with striking, vintage-style Lambeth piping and a delicate bow.",
    image: vintageheartbow,
  },
  {
    id: 17,
    name: "Drip Heart Cake (H02)",
    price: "From £39",
    sizes: setSizes({
      "8 Inch": 39,
      "10 Inch": 51,
      "12 Inch": 68,
    }),
    category: "Heart",
    desc: "Heart-shaped bliss topped with a perfect drip edge.",
    longDesc:
      "Deep, dark, and romantic. This heart-shaped marvel features a rich, egg-free chocolate sponge interior, coated in smooth buttercream and crowned with a flawless, continuous drip edge.",
    image: dripheartcake,
  },
  {
    id: 18,
    name: "Peach Heart Cake (H03)",
    price: "From £34",
    sizes: setSizes({
      "8 Inch": 34,
      "10 Inch": 45,
      "12 Inch": 65,
    }),
    category: "Heart",
    desc: "A lovely soft peach frosted cake baked with love.",
    longDesc:
      "Soft, sweet, and enchanting. A delicate fruit-infused, egg-free Madeira sponge is sculpted into a heart and covered in a beautifully smooth peach-toned buttercream.",
    image: peachheartcake,
  },
  {
    id: 19,
    name: "Egyptian Cotton Cake (H04)",
    price: "From £34",
    sizes: setSizes({
      "8 Inch": 34,
      "10 Inch": 45,
      "12 Inch": 59,
      "14 Inch": 75,
    }),
    category: "Heart",
    desc: "Incredibly soft, pure white creamy heart cake.",
    longDesc:
      "As soft as luxury linen. A heart of exceptionally light, egg-free vanilla Madeira sponge layered with mascarpone, finished with a smooth, pure white cream that melts entirely in the mouth.",
    image: egyptiancottoncake,
  },
  {
    id: 20,
    name: "Pink & White Heart (H05)",
    price: "From £34",
    sizes: setSizes({
      "8 Inch": 34,
      "10 Inch": 45,
      "12 Inch": 59,
      "14 Inch": 75,
    }),
    category: "Heart",
    desc: "Classic split color heart with beautiful piping.",
    longDesc:
      "Understated romance. A classic heart cake elevated by meticulously hand-piped, dual-tone pink and white borders. Inside, a light, egg-free vanilla Madeira sponge with rich fruit compote.",
    image: pinkwhiteheart,
  },
  {
    id: 21,
    name: "Purple Heart (H06)",
    price: "From £34",
    sizes: setSizes({
      "8 Inch": 34,
      "10 Inch": 43,
      "12 Inch": 54,
      "14 Inch": 68,
    }),
    category: "Heart",
    desc: "Beautifully textured vibrant purple frosting.",
    longDesc:
      "A tactile masterpiece. This heart cake features a bespoke, heavily textured deep purple buttercream finish using palette knife techniques, covering a fragrant Earl Grey infused, egg-free Madeira sponge.",
    image: purpleheart,
  },

  // --- Kids & Themed Cakes ---
  {
    id: 22,
    name: "Spiderman Cake (K01)",
    price: "From £31",
    sizes: setSizes({
      "8 Inch": 31,
      "10 Inch": 42,
      "12 Inch": 54,
      "14 Inch": 69,
    }),
    category: "Kids",
    desc: "Action-packed web-slinger themed cake.",
    longDesc:
      "Action-packed design for the ultimate fan. Featuring a striking red and blue color palette with hand-piped web detailing over a kid-friendly, super-moist, egg-free chocolate sponge.",
    image: spidermancake,
  },
  {
    id: 23,
    name: "Your Team Cake (K02)",
    price: "From £33",
    sizes: setSizes({
      "8 Inch": 33,
      "10 Inch": 48,
      "12 Inch": 63,
      "14 Inch": 80,
    }),
    category: "Kids",
    desc: "Customizable colors for your favorite sports team.",
    longDesc:
      "Celebrate the beautiful game. A sharp cake decorated with your custom team colors and classic sports styling, hiding a crowd-pleasing, egg-free vanilla Madeira interior.",
    image: teamcake,
  },
  {
    id: 24,
    name: "Mickey Mouse Cake (K03)",
    price: "From £39",
    sizes: setSizes({
      "6 Inch": 30,
      "8 Inch": 40,
      "10 Inch": 52,
      "12 Inch": 66,
      "14 Inch": 81,
    }),
    category: "Kids",
    desc: "The beloved classic cartoon mouse cake.",
    longDesc:
      "Nostalgic and joyful. This cake features the iconic colors and subtle silhouette nods to everyone's favorite cartoon mouse, crafted with premium, egg-free, kid-approved ingredients.",
    image: mickeymouse,
  },
  {
    id: 25,
    name: "Minnie Mouse Cake (K04)",
    price: "From £29",
    sizes: setSizes({
      "6 Inch": 29,
      "8 Inch": 39,
      "10 Inch": 51,
      "12 Inch": 65,
      "14 Inch": 80,
    }),
    category: "Kids",
    desc: "The beloved classic cartoon mouse cake.",
    longDesc:
      "Bright, bold, and beautiful. A vibrant pink cake adorned with white polka dots and a signature sugar bow, concealing a delicious, egg-free vanilla Madeira sponge layered with a sweet, fresh strawberry buttercream.",
    image: minniemouse,
  },
  {
    id: 26,
    name: "Barbie Cake (K05)",
    price: "From £24",
    sizes: setSizes({
      "6 Inch": 24,
      "8 Inch": 34,
      "10 Inch": 47,
    }),
    category: "Kids",
    desc: "Enchanting fashion doll themed pink cake.",
    longDesc:
      "A magical creation for a special day. Soft pink tones, edible glitter, and delicate sugar accents adorn this enchanting cake, concealing a light and fluffy, egg-free funfetti Madeira sponge.",
    image: barbiecake,
  },
  {
    id: 27,
    name: "Peppa Pig Cake (K06)",
    price: "From £26",
    sizes: setSizes({
      "6 Inch": 26,
      "8 Inch": 36,
      "10 Inch": 47,
      "12 Inch": 59,
      "14 Inch": 74,
    }),
    category: "Kids",
    desc: "Fun puddle-jumping character cake.",
    longDesc:
      "Inspired by the favorite puddle-jumping character. A cheerful, brightly colored cake featuring a blue sky and green hill motif, layered with a delicious, egg-free chocolate orange sponge.",
    image: peppapigcake,
  },
  {
    id: 28,
    name: "Baby Shark Cake (K07)",
    price: "From £29",
    sizes: setSizes({
      "6 Inch": 29,
      "8 Inch": 41,
      "10 Inch": 64,
      "12 Inch": 74,
    }),
    category: "Kids",
    desc: "Colorful underwater themed ocean cake.",
    longDesc:
      "An underwater adventure. Featuring a stunning ocean-blue buttercream exterior and aquatic themed piping, this cake is pure fun inside and out, featuring our signature egg-free vanilla Madeira sponge.",
    image: babysharkcake,
  },
  {
    id: 29,
    name: "Bluey Cake (K08)",
    price: "From £42",
    sizes: setSizes({
      "6 Inch": 42,
      "8 Inch": 66,
      "10 Inch": 76,
      "12 Inch": 87,
    }),
    category: "Kids",
    desc: "Everyone's favorite blue animated dog.",
    longDesc:
      "A tribute to the beloved blue pup. This fun cake features distinct blue and orange hues in a playful design, paired with a classic, egg-free vanilla Madeira sponge and jam filling.",
    image: blueycake,
  },

  {
    id: 30,
    name: "Number Cake (A01)",
    price: "From £29",
    sizes: setSizes({
      "8 Inch": 29,
      "10 Inch": 39,
      "12 Inch": 51,
      "14 Inch": 62,
      "16 Inch": 75,
    }),
    category: "Assortment",
    desc: "Custom shaped number cake for milestones.",
    longDesc:
      "Mark the milestone in style. A bespoke, hand-carved number cake, decorated with a luxurious array of macarons, fresh florals, and edible gold over a premium, egg-free Madeira sponge base.",
    image: numbercake,
  },
  {
    id: 31,
    name: "Large Celebration Cake (A02)",
    price: "From £163",
    sizes: setSizes({
      "18 x 30 Inch": 163,
    }),
    category: "Assortment",
    desc: "A large celebration cake with fruits.",
    longDesc:
      "Celebrate in style with this large, show-stopping cake. Perfect for big events, it features a rich, egg-free chocolate sponge layered with fresh cream and seasonal fruits, finished with elegant piping and a glossy ganache.",
    image: chocolateandfruitcake,
  },
  {
    id: 32,
    name: "Baby Celebration Cake (A03)",
    price: "From £158",
    sizes: setSizes({
      "18 x 30Inch": 158,
    }),
    category: "Assortment",
    desc: "A large baby celebration cake with fruits.",
    longDesc:
      "Celebrate the new arrival in style. This cake features a soft, egg-free vanilla Madeira sponge, adorned with fresh fruits and subtle sugar decorations, perfect for welcoming a new baby.",
    image: welcomecake,
  },
  {
    id: 33,
    name: "Vanilla Gift Box (G01)",
    price: "From £3",
    sizes: setSizes({
      "Standard Box": 3,
    }),
    category: "Gift Boxes",
    desc: "A delightful vanilla sponge packaged perfectly for gifting.",
    longDesc:
      "Perfect for a sweet little surprise. Our signature egg-free vanilla Madeira sponge, elegantly presented in a bespoke, ready-to-gift box.",
    image: vanillagiftbox,
  },
  {
    id: 34,
    name: "Chocolate Gift Box (G02)",
    price: "From £3.50",
    sizes: setSizes({
      "Standard Box": 3.5,
    }),
    category: "Gift Boxes",
    desc: "A rich chocolate sponge packaged perfectly for gifting.",
    longDesc:
      "The perfect treat for chocolate lovers. Rich, egg-free chocolate sponge topped with decadent buttercream, beautifully packaged in a convenient gift box.",
    image: chocolategiftbox,
  },
  {
    id: 35,
    name: "Red Velvet Gift Box (G03)",
    price: "From £3.50",
    sizes: setSizes({
      "Standard Box": 3.5,
    }),
    category: "Gift Boxes",
    desc: "A vibrant red velvet treat packaged perfectly for gifting.",
    longDesc:
      "A touch of everyday luxury. Our signature egg-free red velvet sponge paired with perfectly tangy cream cheese frosting, presented in an elegant gift box.",
    image: redvelvetgiftbox,
  },
  {
    id: 36,
    name: "Cake Slices Selection (SL01)",
    price: "From £3.50",
    sizes: setSizes({
      "Vanilla Slice": 3.5,
      "Coconut Slice": 3.5,
      "Chocolate Slice": 4,
      "Biscoff Slice": 4,
      "Red Velvet Slice": 4,
      "Kinder Bueno Slice": 4,
      "Ferrero Rocher Slice": 4,
      "Raffaello Slice": 4,
      "Gulab Jamun Slice": 4.5,
      "Pistachio Slice": 4.5,
    }),
    category: "Slices",
    desc: "A selection of our finest cake slices, perfect for a treat.",
    longDesc:
      "Choose from our wide variety of handcrafted, egg-free cake slices. Whether you crave a classic Vanilla, a rich Biscoff, or an aromatic Gulab Jamun fusion, there is a slice for everyone. Simply select your flavor and quantity below.",
    image: slicesimage,
  },
];
